const IDLE_CALLBACK_FALLBACK_TIMEOUT = 100;
function requestIdleCallbackFallback(callback, options) {
  return setTimeout(
    callback,
    Math.min(options?.timeout ?? Infinity, IDLE_CALLBACK_FALLBACK_TIMEOUT)
  );
}
const requestIdleCallback = (typeof window !== "undefined" ? window.requestIdleCallback : null) ?? requestIdleCallbackFallback;
const cancelIdleCallback = (typeof window !== "undefined" ? window.cancelIdleCallback : null) ?? clearTimeout;

export { cancelIdleCallback, requestIdleCallback };
//# sourceMappingURL=request-idle-callback.mjs.map
